<template>

    <footer class="footer-bloc">

        <div class="footer-container">

            <div class="footer-flex footer-flex-2">

                <img class="footer-logo" src="/img/logo/large/white.svg" alt="logo">

                <lang-switch></lang-switch>

            </div>

            <div class="footer-flex">

                <h2 class="footer-section">{{ $t('footer_company') }}</h2>

                <a @click="goPage('about')" class="footer-link">{{ $t('footer_about_us') }}
                </a>

                <a @click="goPage('foxintelligence')" class="footer-link">{{
                    $t('footer_foxintelligence') }}
                </a>

                <a @click="goPage('press')" class="footer-link">{{ $t('footer_press') }}
                </a>

                <div class="footer-space"></div>

            </div>

            <div class="footer-flex">

                <h2 class="footer-section">{{ $t('footer_resources') }}</h2>

                <a @click="goPage('privacy')" class="footer-link">{{ $t('footer_privacy') }}
                </a>

                <a @click="goPage('terms')" class="footer-link">{{ $t('footer_terms') }}
                </a>

                <a @click="goPage('faq')" class="footer-link">{{ $t('footer_faq') }}
                </a>

                <a @click="goPage('my-data')" class="footer-link">{{ $t('new_footer_data_use') }}
                </a>

                <a v-if="isDeutsch" @click="goPage('impressum')" class="footer-link">{{ $t('footer_impressum') }}
                </a>

                <div class="footer-space"></div>

            </div>

            <div class="footer-flex">


                <a v-if="isFrench" class="footer-section pointer" href="https://cleanfox.io/blog/fr/" target="_blank"> {{ $t('footer_blog') }}</a>
                <a v-else class="footer-section pointer" href="https://cleanfox.io/blog/en/" target="_blank">{{ $t('footer_blog') }}</a>

                <a v-if="isFrench" href="https://cleanfox.io/blog/pollution-numerique-fr/" class="footer-link" target="_blank">{{ $t('footer_pollution')}}</a>
                <a v-else href="https://cleanfox.io/blog/digital-pollution-en/" class="footer-link" target="_blank">{{ $t('footer_pollution')}}</a>

                <a v-if="isFrench" href="https://cleanfox.io/blog/astuces-fr/" class="footer-link" target="_blank">{{ $t('footer_tips') }}</a>
                <a v-else href="https://cleanfox.io/blog/tips-en/" class="footer-link" target="_blank">{{ $t('footer_tips') }}</a>

                <a v-if="isFrench" href="https://cleanfox.io/blog/actualite-fr/" class="footer-link" target="_blank">{{ $t('footer_news') }}</a>
                <a v-else href="https://cleanfox.io/blog/cleanfox-news-en/" class="footer-link" target="_blank">{{ $t('footer_news') }}</a>

                <a v-if="isFrench" href="https://cleanfox.io/blog/astuces-fr/se-connecter-a-sa-boite-mail-hotmail/" class="footer-link" target="_blank">{{ $t('footer_connect_hotmail') }}</a>
                <a v-else href="https://cleanfox.io/blog/tips-en/connect-to-your-hotmail-mailbox/" class="footer-link" target="_blank">{{ $t('footer_connect_hotmail') }}</a>

            </div>

            <div class="footer-space"></div>

            <div class="footer-flex">

                <mq-layout :mq="['sm', 'md']" class="footer-flex">

                    <a class="footer-section" target="_blank"
                       href="https://app.adjust.com/uez2im">{{
                        $t('footer_android_app') }}</a>

                    <a class="footer-section" target="_blank"
                       href="https://app.adjust.com/uez2im?deep_link=cleanfox://&redirect=https://itunes.apple.com/fr/app/cleanfox/id1136298377?mt=8">{{ $t('footer_ios_app') }}</a>

                </mq-layout>


                <mq-layout mq="lg" class="footer-flex">

                    <h2 class="footer-section">{{ $t('footer_our_app') }}</h2>

                    <a class="footer-link" target="_blank"
                       href="https://app.adjust.com/uez2im">{{
                        $t('footer_android_app') }}</a>

                    <a class="footer-link" target="_blank"
                       href="https://app.adjust.com/uez2im?deep_link=cleanfox://&redirect=https://itunes.apple.com/fr/app/cleanfox/id1136298377?mt=8">{{ $t('footer_ios_app') }}</a>


                </mq-layout>


                <mq-layout mq="lg" class="footer-flex">

                    <h2 class="footer-section">{{ $t('footer_community') }}</h2>

                </mq-layout>

                <div class="footer-media-container">

                    <img class="footer-media pointer" src="/img/share/little-facebook-white.svg" @click="goFacebook" alt="facebook">

                    <img class="footer-media pointer" src="/img/share/little-twitter-white.svg" @click="goTwitter" alt="twitter">

                    <img class="footer-media pointer" src="/img/share/little-instagram-white.svg" @click="goInstagram" alt="instagram">

                </div>

            </div>

        </div>

        <div class="bottom-bloc-container">

            <div class="bottom-bloc">

                <span class="copyright">{{ $t('footer_copyright', 0, { year }) }}</span>

                <span class="made_with_love">{{ $t('footer_with_love') }}</span>

            </div>

        </div>

    </footer>

</template>

<script>

import I18n from '@/modules/i18n'
import Tag from '@/modules/tag'

import LangSwitch from '@/components/LangSwitch'

export default {

    name: 'footer-landing',

    components: { LangSwitch },

    computed: {

        isDeutsch () {
            return I18n.get(this) === 'de'
        },

        isFrench () {
            return I18n.get(this) === 'fr'
        }
    },

    data () {
        return {
            year: new Date().getFullYear()
        }
    },

    methods: {

        goFacebook () {
            window.open('https://www.facebook.com/cleanfox/')
        },

        goTwitter () {
            window.open('https://twitter.com/cleanfoxapp?lang=en')
        },

        goInstagram () {
            window.open('https://www.instagram.com/cleanfox_/?hl=en')
        },

        goPage (page) {

            Tag.clickGA(this, page)
            this.$router.push({ path: `/${page}` })
        }
    }

}

</script>

<style scoped lang="scss">

    .footer-bloc {
        background-color: $blue;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
    }

    .footer-container {
        padding: 26px 16px 30px;
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 100%;
        max-width: $max-wrapper;
        @media screen and (min-width: $above-tablet-length) {
            flex-direction: row;
            padding: 40px 32px 60px;
        }
    }

    .footer-logo {
        height: 57px;
        margin-left: -4px;
        margin-bottom: 18px;
    }

    .footer-section {
        font-size: 16px;
        font-weight: bold;
        color: $white;
        margin-top: 16px;
        margin-bottom: 6px;
    }

    .footer-link {
        font-size: 14px;
        color: $white;
        margin-top: 16px;
        cursor: pointer;
        padding-right: 16px;
        @media screen and (min-width: $above-tablet-length) {
            text-align: left;
        }
    }

    .footer-space {
        height: 13px;
    }

    .footer-media-container {
        margin-top: 19px;
        display: flex;
    }

    .footer-media {
        margin-right: 25px;
        width: 24px;
        object-fit: contain;
    }

    .bottom-bloc-container {
        width: 100%;
        padding: 24px 0 20px;
        background-color: rgb(58, 121, 164);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        @media screen and (min-width: $above-tablet-length) {
            padding: 24px 32px 19px;
        }
    }

    .bottom-bloc {
        display: flex;
        flex-direction: column;
        max-width: $max-wrapper;
        justify-content: space-around;
        height: 100%;
        @media screen and (min-width: $above-tablet-length) {
            width: 100%;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
        }
    }

    .copyright {
        font-size: 12px;
        color: $white;
        opacity: 0.6;
    }

    .made_with_love {
        font-size: 14px;
        color: $white;
        margin-top: 28px;
        @media screen and (min-width: $above-tablet-length) {
            margin-top: 0px;
        }
    }

    .footer-flex {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        flex: 1;
    }

    .footer-flex-2 {
        @media screen and (min-width: $above-tablet-length) {
            flex: 2;
        }
    }

</style>
